import React from 'react';
import Head from 'next/head';
import { useTranslation } from 'next-i18next';
import { useRollbarContext } from '@services/rollbar';
import ssrProvider from '@services/ssrProvider';
import { GET_DATA_FOR, getServerSideData } from '@services/dataHandler/getPageData';
import ReduxWrapper from '@services/store';
import EventListTemplate from '@features/eventList/templates/EventListTemplate';

const EventsPage = () => {
  useRollbarContext('EventsListPage');
  const { t } = useTranslation();
  return (
    <>
      <Head>
        <title>
          {`${t('head_eventsPageTitle.message')} ${t('head_siteTitle.message')}`}
        </title>
        <meta
          name="description"
          content={
            t('head_eventsPageDescription.message')
          }
        />
      </Head>
      <EventListTemplate />
    </>
  );
};

export default EventsPage;

export const getServerSideProps = ReduxWrapper.getServerSideProps(
  (store) => async (serverSideContext) => ssrProvider({
    store,
    serverSideContext,
    process: async ({ store }) => {
      await getServerSideData(
        store,
        serverSideContext,
        GET_DATA_FOR.EVENT_LIST,
      );
    },
  })
);
